module.exports = "/static/media/background-white.0a893a40.png";